import * as React from 'react';

import { maybe } from '@rematter/ui-web';
import { EntityDetails } from '@rematter/ui-web';
import { useAtom, useAtomValue } from 'jotai';

import * as state from '../../_state/purchaseOrderDetails.state';
import { customerPortalRoutes } from '../../routes';
import { EntityTabLoads } from '../_shared/EntityTabLoads';

import { PurchaseOrderStatusBadge } from './PurchaseOrderBadges';
import { PurchaseOrderHeaderActions } from './PurchaseOrderHeaderActions';
import { PurchaseOrderTabAttachments } from './PurchaseOrderTabAttachments';
import { PurchaseOrderTabContract } from './PurchaseOrderTabContract';
import { PurchaseOrderTabMaterials } from './PurchaseOrderTabMaterials';
import { PurchaseOrderTabNotes } from './PurchaseOrderTabNotes';

import { useModuleLocation } from '~/shared/hooks/useModuleLocation';

export type PurchaseOrderDetailsViewProps = {
  children?: React.ReactNode;
};

export const PurchaseOrderDetailsView = ({
  children,
}: PurchaseOrderDetailsViewProps) => {
  const [tab, setTab] = useAtom(state.$tab);
  const [, navigate] = useModuleLocation();
  const { data: purchaseOrder } = useAtomValue(state.$purchaseOrderDetails);

  const handleBackPressed = React.useCallback(() => {
    navigate(customerPortalRoutes.purchaseOrders, { replace: true });
  }, [navigate]);

  return (
    <div className="@PurchaseOrderDetailsView contents">
      <EntityDetails
        tabs={{
          contract: {
            title: 'Contract',
            content: PurchaseOrderTabContract,
          },
          materials: {
            title: 'Materials',
            content: PurchaseOrderTabMaterials,
          },
          loads: {
            title: 'Loads',
            content: EntityTabLoads,
          },
          attachments: {
            title: 'Attachments',
            content: PurchaseOrderTabAttachments,
          },
          notes: {
            title: 'Notes',
            content: PurchaseOrderTabNotes,
          },
        }}
        currentTab={tab}
        onChangeTab={(tab) => setTab(tab, { replace: true })}
        primaryTitle={purchaseOrder?.supplier?.name ?? 'Loading...'}
        secondaryTitle={maybe(
          purchaseOrder?.purchaseOrderNumber,
          (poNumber) => `#${poNumber}`,
        )}
        badges={
          purchaseOrder?.status && (
            <PurchaseOrderStatusBadge status={purchaseOrder?.status} />
          )
        }
        headerActions={<PurchaseOrderHeaderActions />}
        onBackPressed={handleBackPressed}
      />
      {children}
    </div>
  );
};
